import { heroStyle } from "../styles/mainStyles";

function BodyWrapper({ children }) {
    return (
        <>
        <div
            className="d-flex flex-column justify-content-center align-items-center text-center text-white"
            style={heroStyle}
        >
                {children}
        </div>
        </>
    );
}

export default BodyWrapper;
